export default {
  'cdnResources.list.deleteCdn.message': '删除成功',
  'cdnResources.list.columns.Tag.suspend': '暂停',
  'cdnResources.list.Popconfirm.title': '您确定删除该CDN资源吗？',
  'cdnResources.list.Popconfirm.okText': '是的',
  'cdnResources.list.Popconfirm.cancelText': '不，取消',
  'cdnResources.list.Modal.Cancel': '取消',
  'cdnResources.list.title': 'CDN资源',
  'cdnResources.list.Create': '创建新的CDN资源',
  'cdnResources.list.Create.ResourceName': '资源名称',
  'cdnResources.list.Create.Disabled': '已达到上限',
  //v1.2.0
  'cdnResources.list.ConfirmAndCreate': '确认并创建',
  'cdnResources.list.Empty.btnText': '开始加速',
  'cdnResources.list.Empty.desc': '3分钟创建资源，开启加速',
  'cdnResources.list.columns.title1': 'CDN加速域名',
  'cdnResources.list.columns.title2': 'CNAME',
  'cdnResources.list.columns.title3': '来源',
  'cdnResources.list.columns.title4': '操作选项',
  'cdnResources.list.columns.title7': '来源类型',
  //v1.2.0
  'cdnResources.list.columns.title5': '档位',
  'cdnResources.list.columns.title6': '本月用量',
  'cdnResources.list.PopoverText1': '数据详情',
  'cdnResources.list.PopoverText2': '设置',
  'cdnResources.list.PopoverText3': '删除资源',
  'cdnResources.list.PopoverText4': '清除所有缓存',
  //v1.3.3
  'cdnResources.create.stepBox.step0': '填写资源信息',
  'cdnResources.create.stepBox.step1': '选择档位',
  'cdnResources.create.step0.title1': '创建加速资源',
  'cdnResources.create.step0.title2': '获取来源',
  'cdnResources.create.step0.type1': '源URL',
  'cdnResources.create.step0.type2': '对象存储',
  'cdnResources.create.step0.sourceHostName': '回源主机名',
  'cdnResources.create.step0.sourceHostName.text':
    '回源主机名的选择影响到请求源站时接收到的域名。默认类型仅供参考，',
  'cdnResources.create.step0.btn': '去选择您的节点档位',

  'cdnResources.create.step1.fristFree': '前{val}免费',
  // 'cdnResources.create.stepBox.step1': '基础设置',
  'cdnResources.create.stepBox.step2': '完成',
  'cdnResources.create.onSubmit.message': '创建成功',
  'cdnResources.create.step1.validatorCdnHostName.same': 'CDN加速域名和源是一样的',
  'cdnResources.create.step1.Form.cdnHostName.name': 'CDN加速域名',
  'cdnResources.create.step1.Form.cdnHostName.message': '请输入您的CDN加速域名！',
  'cdnResources.create.step1.Form.origin.protocol': '源政策',
  'cdnResources.create.step1.Form.origin.name': '来源',
  'cdnResources.create.step1.Form.origin.message': '请输入来源！',
  'cdnResources.create.step1.Form.Checkbox.name': '使用自定义端口',
  'cdnResources.create.step1.Form.port.name': '端口（非必填）',
  'cdnResources.create.step1.Form.port.message': '请输入端口号！',
  'cdnResources.create.step1.Form.port.80': '80通常是HTTP协议端口，请确认源站协议选择是否正确。',
  'cdnResources.create.step1.Form.port.443': '443通常是HTTPS协议端口，请确认源站协议选择是否正确。',
  'cdnResources.create.step2.message': '创建成功',
  'cdnResources.create.step2.title1': 'CDN资源已经创建成功，CNAME将在',
  'cdnResources.create.step2.title2': '秒内生成',
  'cdnResources.create.step1.tip1':
    '您要加速的网址通常是对用户开放的公开显示地址。 完成后，您可以使用我们的 CNAME 或您的显示地址来加速您的资源。',
  'cdnResources.create.step1.tip2': '您要加速的网址通常是对用户开放的公开显示地址。',
  'cdnResources.create.step1.tip2.1': '在此处填写web内容源的地址，可以是URL或IP。',
  'cdnResources.create.step1.tip3': '(注意URL格式：{domain1}、 {domain2}，不支持{domain3}）',
  'cdnResources.create.step1.tip3.0':
    '完成后，您可以使用我们的 CNAME 或您的显示地址来加速您的资源。请注意一行一个CDN加速域名。',
  'cdnResources.create.step1.tip3.1': '注意URL格式：',
  'cdnResources.create.step1.tip4': '来源政策为AUTO时，不支持填写端口。',
  'cdnResources.create.step1.tip5': '（泛域名需要单独创建）',
  'cdnResources.create.step1.tip6': '泛域名需要单独创建',
  'cdnResources.create.step1.NotSupported': '（暂时不支持）',
  'cdnResources.create.step1.help1': '如果你需要更多帮助，你可以 ',
  'cdnResources.create.step1.help2': '点击这里。',
  'cdnResources.create.step1.origin.note1': '请注意：',
  'cdnResources.create.step1.origin.note2': '多源仅能以IP的格式填写，端口号必须一致。',
  'cdnResources.create.step1.origin.message': '超过一条源时，仅可使用IP地址。',
  'cdnResources.create.step1.origin.validatorMessage1': '请填写有效的源。',
  'cdnResources.create.step1.origin.validatorMessage2': '请填写有效的加速域名。',
  'cdnResources.create.step1.origin.validatorMessage3': '这个IP地址已存在。',
  'cdnResources.create.step1.origin.validatorMessage4': '请填写有效的IP地址。',
  'cdnResources.create.step1.origin.validatorMessage5': '多源时，端口号必须一致。',
  'cdnResources.create.step1.origin.validatorMessage6': '当前加速域名不可创建。',
  'cdnResources.create.step1.origin.validatorMessage7': '请输入最多 10 个 IP',
  'cdnResources.create.step1.origin.unique': '源已经存在',
  'cdnResources.create.step1.hostname.unique': 'CDN加速域名已存在。',
  'cdnResources.create.step1.resourceName.unique': '资源名称已存在。',
  //v1.2.0
  'cdnResources.create.StandardNetwork': '标准网络',
  'cdnResources.create.CoreNetwork': '核心网络',
  'cdnResources.create.noPlan.modal.text': '余额不足&没有计划',
  'cdnResources.create.noPlan.modal.p': '您还有免费流量可以兑换！',
  'cdnResources.create.noPlan.modal.button': '获取方案',
  'cdnResources.create.No.additional': '无额外收费。',
  'cdnResources.detail.tabKey4.tier.Current': '当前档位',
  'cdnResources.detail.tabKey4.tier.edit': '更换档位',
  'cdnResources.detail.tabKey4.tier.Usage': '本月用量',
  'cdnResources.detail.tabKey4.tier.Unitprice': '单价',
  'cdnResources.detail.tabKey4.EnableEdgeLocation': '开启边缘位置',
  'cdnResources.detail.tabKey4.tier.Modal.p1': '您当前没有此边缘位置的权限。请切档位，然后重试。',
  'cdnResources.detail.tabKey4.tier.Recommended': '推荐档位：',
  'cdnResources.create.NetworkList.moreFavorable': '点击此处获取更优惠的价格',
  'cdnResources.create.title.resources': '创建您的CDN资源',
  'cdnResources.create.title.tier': '选择您的档位',
  'cdnResources.create.tier.loading': '正在为你处理资源，请等待...',
  'cdnResources.create.NetworkList.tierRecharge.p1': '以下档位需要确保余额充足，',
  'cdnResources.create.NetworkList.tierRecharge.p2': '请前往充值',
  'cdnResources.create.NetworkList.planLearn.p1':
    '您当前有一个月度计划，该计划将自动激活相应的档位。',
  'cdnResources.create.NetworkList.planLearn.p2': '了解你的月度计划',
  'cdnResources.create.postpaid.price.p':
    '如果半小时的流量极小，我们将扣除0.000001美元的最低金额。如果超过此金额，我们将根据正常计费扣除。',
  'cdnResources.detail.NoPermission': '无权限',
  'cdnResources.detail.SuggestedTier': '建议档位：',

  'cdnResources.detail.title': 'CDN资源',
  'cdnResources.detail.tabKey1': '基础设置',
  'cdnResources.detail.tabKey2': '高级设置',
  'cdnResources.detail.tabKey3': '加速位置',
  'cdnResources.detail.tabKey4': '清除',
  'cdnResources.detail.tabKey5': '预存',
  'cdnResources.detail.tabKey6': '激活配置',
  'cdnResources.detail.tabKey7': '安全保护',
  'cdnResources.detail.tabKey8': '规则集',
  'cdnResources.detail.tabKey9': '性能优化',
  'cdnResources.detail.tabKey1.onSuccess.message': '更新成功',
  'cdnResources.detail.tabKey1.title': '基础信息',
  'cdnResources.detail.tabKey1.cdnHostName.name': 'CDN加速域名',
  'cdnResources.detail.tabKey1.cdnHostName.message': '请输入',
  'cdnResources.detail.tabKey1.cdnHostName.placeholder': '每个CDN加速域名都需要填写一行，最多15行',
  'cdnResources.detail.tabKey1.cdnHostName.validatorMessage': '请输入有效的主机名。',
  // 'cdnResources.detail.tabKey1.origin.name': 'Origin',
  'cdnResources.detail.tabKey1.port.name': '端口',
  'cdnResources.detail.tabKey1.select.message': '请选择',
  'cdnResources.detail.tabKey1.Button': '新增',
  'cdnResources.detail.tabKey1.https.title': 'HTTPS配置',
  'cdnResources.detail.tabKey1.https.alert':
    '请注意，当前资源绑定的以下域名尚未配置证书，将无法通过HTTPS协议访问：',
  'cdnResources.detail.tabKey1.https.TLS.title': 'TLS最低版本',
  'cdnResources.detail.tabKey1.https.TLS.tip':
    'TLS的选择上，建议使用TLS1.2或1.3。当前1.0和1.1的版本存在已知漏洞，应该避免使用。',
  'cdnResources.detail.tabKey1.https.HTTP2.title': '启用HTTP/2',
  'cdnResources.detail.tabKey1.https.HTTP2.tip':
    '开启HTTP/2 能显著提升性能改善用户体验。注意确保配置了正确的证书的情况下，才能生效。',
  'cdnResources.detail.tabKey1.ssl.title': 'SSL',
  'cdnResources.detail.tabKey1.ssl.Tag1': '已启用',
  'cdnResources.detail.tabKey1.ssl.Tag2': '未启用',
  'cdnResources.detail.tabKey1.ssl.tip':
    '加速域名必须具有SSL证书，才能通过HTTPS访问。您可以打开SSL证书来配置域名。',
  'cdnResources.detail.tabKey1.ssl.tip1':
    '若你有多个CDN加速域名，可以选择上传多个对应的SSL证书，或通配符证书来确保所有加速域名都可以通过HTTPS访问。',
  'cdnResources.detail.tabKey1.ssl.tip11': '请确保您的',
  'cdnResources.detail.tabKey1.ssl.tip22': '所有',
  'cdnResources.detail.tabKey1.ssl.tip33': 'CDN主机名都已解析为CNAME，否则免费证书将无法打开。',
  'cdnResources.detail.tabKey1.ssl.group.label1': "Let's Encrypt",
  'cdnResources.detail.tabKey1.ssl.group.p1':
    "请输入完成的主机名，并确保它不以'.cdn95.com'结尾，不然他将无法自动开启SSL证书。",
  'cdnResources.detail.tabKey1.ssl.group.label2': '自定义 SNI SSL',
  'cdnResources.detail.tabKey1.ssl.group.p2':
    '若开启辅助加速域名，自定义SNI证书将同时作用于加速域和辅助加速域。',
  'cdnResources.detail.tabKey1.HostName.title': '辅助加速域名',
  'cdnResources.detail.tabKey1.HostName.modal.title': '保存',
  'cdnResources.detail.tabKey1.HostName.modal.text1':
    "如果你开启了辅助加速域名，我们将自动为你切换或开启Let's Encrypt SSL证书。",
  'cdnResources.detail.tabKey1.HostName.modal.text2': '请确认是否需要开启辅助加速域名？',
  'cdnResources.detail.tabKey1.HostName.message1': '可以填写的CDN加速域名已超过上限！',
  'cdnResources.detail.tabKey1.HostName.message2': '不能重复或跟CDN加速域名相同。',
  'cdnResources.detail.tabKey1.HostName.message3': '填写的域名不可跟加速域相同。',
  'cdnResources.detail.tabKey1.HostName.message4': '不能重复或与CDN加速域名相同。', //和辅助CDN加速域名
  'cdnResources.detail.tabKey1.HostName.message5': '不能重复或跟来源相同。',
  'cdnResources.detail.tabKey1.HostName.message6': '不能重复。',
  'cdnResources.detail.tabKey1.HostName.tip0.0':
    '若你使用的是免费证书，加速域名变更并确保新域名cname解析完成后，需要重新关闭开启免费证书以确保证书同步给新的域名。',
  'cdnResources.detail.tabKey1.HostName.tip0':
    'CDN 加速域名支持添加多个。请注意一行一个CDN加速域名。',
  'cdnResources.detail.tabKey1.HostName.tip1':
    'CDN辅助域支持添加多个加速域名，用户可以利用并行下载来加快页面加载速度。您需要为CDN主机名和辅助CDN主机名称设置CNAME。更多详情',
  'cdnResources.detail.tabKey1.HostName.tip2': '查看文档',
  'cdnResources.detail.tabKey1.origin.toRules': '有关更多源设置，请访问',
  'cdnResources.detail.tabKey2.tip.name': '如何绕过 LightCDN 的边缘服务器直接访问源呢？',
  'cdnResources.detail.tabKey2.tip.pop': '点击进入引导',
  'cdnResources.detail.tabKey2.tip.content':
    '你可以尝试为特定的文件将具有 Cache-Control 标头的CDN资源的缓存规则添加为“no-cache”或者“max-age = 0”。同时，您可以将Force Edge设置为从不缓存，这将强制CDN边缘服务器在缓存规则中从不缓存请求。',
  'cdnResources.detail.tabKey2.HLS_force_cache.name': 'HLS 强制缓存',
  'cdnResources.detail.tabKey2.HLS_force_cache.p1':
    '强制m3u8文件边缘服务器不缓存并支持设置过期时间。 该设置仅在启用',
  'cdnResources.detail.tabKey2.HLS_force_cache.p2': '“HLS优化”',
  'cdnResources.detail.tabKey2.HLS_force_cache.p3': '时生效。',
  'cdnResources.detail.tabKey2.title': '缓存过期时间',
  'cdnResources.detail.tabKey2.Modal.title': '添加SSL证书',
  'cdnResources.detail.tabKey2.cacheExpiry.name': '缓存有效期',
  'cdnResources.detail.tabKey2.cacheExpiry.message': '请输入缓存有效期！',
  'cdnResources.detail.tabKey2.cacheExpiry.fieldProps': '分钟 (默认12天)',
  'cdnResources.detail.tabKey2.cacheExpiry.default': '默认',
  'cdnResources.detail.tabKey2.cacheExpiry404.name': '404状态码的缓存有效期',
  'cdnResources.detail.tabKey2.cacheExpiry404.fieldProps': '1分钟 (默认)',
  'cdnResources.detail.tabKey2.cacheExpiry.tip1':
    '当前缓存时间为针对全站的缓存，当你拥有动态内容时，',
  'cdnResources.detail.tabKey2.cacheExpiry.tip2': '该如何确保动态内容不被缓存呢？ →',
  'cdnResources.detail.tabKey2.rules.title': '配置',
  'cdnResources.detail.tabKey2.originPolicy.name': '来源政策',
  'cdnResources.detail.tabKey2.originPolicy.label1': '自动',
  'cdnResources.detail.tabKey2.originPolicy.label2': 'HTTP',
  'cdnResources.detail.tabKey2.originPolicy.label3': 'HTTPS',
  'cdnResources.detail.tabKey2.originPolicy.tip1':
    'LightCDN的来源政策选项允许您设置从CDN边缘服务器到源服务器的拉取请求的协议。你可以',
  'cdnResources.detail.tabKey2.originPolicy.tip2': '查看文档',
  'cdnResources.detail.tabKey2.originPolicy.tip3': '来了解更多。',
  'cdnResources.detail.tabKey2.originPolicy.p1':
    'HTTP—边缘服务器和始终使用HTTP的源之间的连接。它是默认值。',
  'cdnResources.detail.tabKey2.originPolicy.p2': 'HTTPS—边缘服务器和始终使用HTTPS的源之间的连接。',
  'cdnResources.detail.tabKey2.originPolicy.p3':
    'AUTO—基于访问者请求（HTTP或HTTPS）的边缘服务器和源服务器之间的连接。但请注意，当您的源已填写端口时，无法选择AUTO。',
  'cdnResources.detail.tabKey2.corsOn.name': 'CORS 标头',
  'cdnResources.detail.tabKey2.corsOn.p1':
    '启用后，通过添加具有访问控制允许源的HTTP标头来启用跨域资源共享（CORS）。',
  'cdnResources.detail.tabKey2.corsOn.p2':
    "若开启后，访问加速域名报错，“No 'Access-Control-Allow-Origin' header is present on the requested resource.” ，可",
  'cdnResources.detail.tabKey2.corsOn.p3': '查看文档',
  'cdnResources.detail.tabKey2.corsOn.p4': '看具体解决方式。',
  'cdnResources.detail.tabKey2.RedirectHttp.name': '将客户端从HTTP重定向到HTTPS',
  'cdnResources.detail.tabKey2.RedirectHttp.p1':
    '开启后，所有HTTP的请求都会自动跳转到对应的HTTPS URL上，端口：',
  'cdnResources.detail.tabKey2.hostHeaderForwarding.name': '主机标头转发',
  'cdnResources.detail.tabKey2.hostHeaderForwarding.p1': `CDN边缘服务器仅在边缘服务器中不存在文件（缓存）时（对于所有场景）才返回原始位置，并且在从CDN边缘-->原始位置的路径中会出现“passthrough http host header to origin”功能。此功能不是“使所有请求返回到源”，而是“将主机标头信息发送到源”。`,
  'cdnResources.detail.tabKey2.IgnoreSetCookie.name': '缓存 Set-Cookie',
  'cdnResources.detail.tabKey2.SkipSetCookie.name': '跳过 set-cookie',
  // 'cdnResources.detail.tabKey2.IgnoreSetCookie.p1':
  //   'CDN为会话跟踪设置cookie。我们的CDN不缓存带有Set-Cookie响应标头的任何内容，包括JPEG文件等静态内容。如果因此导致缓存命中率为0%，请启用此设置，以便缓存此类响应。',
  'cdnResources.detail.tabKey2.IgnoreSetCookie.p1':
    'LightCDN不缓存带有Set-Cookie响应标头的任何内容，包括JPEG等静态内容，如果因此导致缓存命中率0%，请启用此设置，一边缓存此类响应。缓存Set-Cookie的相关内容可以参考',
  'cdnResources.detail.tabKey2.IgnoreSetCookie.p2': '此处文档。',
  'cdnResources.detail.tabKey2.HTTPSRedirect.name': 'HTTPS重定向',
  'cdnResources.detail.tabKey2.HTTPSRedirect.p1':
    '返回从http地址到https地址的301重定向响应，而不是从缓存或上游加载。',
  'cdnResources.detail.tabKey2.StreamingMedia.name': '流媒体',
  'cdnResources.detail.tabKey2.StreamingMedia.MP4': 'MP4伪流',
  'cdnResources.detail.tabKey2.StreamingMedia.FLV': 'FLV伪流媒体',
  'cdnResources.detail.tabKey2.StreamingMedia.HLS': 'HLS优化',
  'cdnResources.detail.tabKey2.StreamingMedia.HLS.p1': '如果您想创建强制缓存过期的规则，可以在',
  'cdnResources.detail.tabKey2.StreamingMedia.HLS.p2': '页面的缓存规则部分快速启用。',

  'cdnResources.detail.tabKey2.Websocket': 'Websocket',
  'cdnResources.detail.tabKey2.Websocket.Enable': '开启 Websocket',
  'cdnResources.detail.tabKey2.Websocket.title1': '服务范围',
  'cdnResources.detail.tabKey2.Websocket.title1.1': '允许所有来源的域名访问Websocket服务。',
  'cdnResources.detail.tabKey2.Websocket.title1.2': '仅允许名单内的域名访问Websocket服务。',
  'cdnResources.detail.tabKey2.Websocket.title1.2.placeholder': '（多域名需要换行填写）',
  'cdnResources.detail.tabKey2.Websocket.title1.2.message': '请填写有效的域名',
  'cdnResources.detail.tabKey2.Websocket.title2': '来源信息',
  'cdnResources.detail.tabKey2.Websocket.title2.1.0': '选中后，收到请求时将传递参数',
  'cdnResources.detail.tabKey2.Websocket.title2.1.1': ' "Origin" ',
  'cdnResources.detail.tabKey2.Websocket.title2.1.2': '到源。',
  'cdnResources.detail.tabKey2.Websocket.title2.2': '指定参数用于传递源信息。',

  'cdnResources.detail.tabKey3.header1': '亚太地区',
  'cdnResources.detail.tabKey3.header2': '中东',
  'cdnResources.detail.tabKey3.header3': '欧洲',
  'cdnResources.detail.tabKey3.header4': '北美地区',
  'cdnResources.detail.tabKey3.header5': '南美地区',
  'cdnResources.detail.tabKey3.header6': '非洲地区',
  'cdnResources.detail.tabKey3.text1': '硅谷',
  'cdnResources.detail.tabKey3.text2': '迈阿密',
  'cdnResources.detail.tabKey3.text3': '华盛顿',
  'cdnResources.detail.tabKey3.text4': '圣保罗',
  'cdnResources.detail.tabKey3.text5': '法兰克福',
  'cdnResources.detail.tabKey3.text6': '迪拜',
  'cdnResources.detail.tabKey3.text7': '新加坡',
  'cdnResources.detail.tabKey3.text8': '胡志明市',
  'cdnResources.detail.tabKey3.text9': '香港',
  'cdnResources.detail.tabKey3.text10': '东京',
  'cdnResources.detail.tabKey3.text11': '利雅得',
  'cdnResources.detail.tabKey3.text12': '开罗',
  'cdnResources.detail.tabKey3.text13': '伦敦',
  'cdnResources.detail.tabKey3.text14': '马赛',
  'cdnResources.detail.tabKey3.text15': '曼谷',
  'cdnResources.detail.tabKey3.text16': '马尼拉',
  'cdnResources.detail.tabKey3.text17': '河内',
  'cdnResources.detail.tabKey3.text18': '金边',
  'cdnResources.detail.tabKey3.text19': '马斯喀特',
  'cdnResources.detail.tabKey3.text20': '约翰内斯堡',
  'cdnResources.detail.tabKey3.text21': '巴林',
  'cdnResources.detail.tabKey3.Panel1': '亚太地区',
  'cdnResources.detail.tabKey3.Panel1.p1': '香港，中国',
  'cdnResources.detail.tabKey3.Panel1.p2': '东京，日本',
  'cdnResources.detail.tabKey3.Panel1.p3': '新加坡',
  'cdnResources.detail.tabKey3.Panel1.p4': '曼谷，泰国',
  'cdnResources.detail.tabKey3.Panel1.p5': '马尼拉，菲律宾',
  'cdnResources.detail.tabKey3.Panel1.p6': '河内，越南',
  'cdnResources.detail.tabKey3.Panel1.p7': '金边，柬埔寨',
  'cdnResources.detail.tabKey3.Panel2': '中东地区',
  'cdnResources.detail.tabKey3.Panel2.p1': '迪拜，阿拉伯联合酋长国',
  'cdnResources.detail.tabKey3.Panel2.p2': '利雅得，沙特阿拉伯',
  'cdnResources.detail.tabKey3.Panel2.p3': '马斯喀特，阿曼',
  'cdnResources.detail.tabKey3.Panel2.p4': '巴林',
  'cdnResources.detail.tabKey3.Panel3': '欧洲',
  'cdnResources.detail.tabKey3.Panel3.p1': '法兰克福，德国',
  'cdnResources.detail.tabKey3.Panel3.p2': '伦敦，英国',
  'cdnResources.detail.tabKey3.Panel3.p3': '马赛，法国',
  'cdnResources.detail.tabKey3.Panel4': '北美',
  'cdnResources.detail.tabKey3.Panel4.p1': '硅谷，美国',
  'cdnResources.detail.tabKey3.Panel4.p2': '华盛顿，美国',
  'cdnResources.detail.tabKey3.Panel5': '南美地区',
  'cdnResources.detail.tabKey3.Panel5.p1': '圣保罗，巴西',
  'cdnResources.detail.tabKey3.Panel6': '非洲地区',
  'cdnResources.detail.tabKey3.Panel6.p1': '开罗，埃及',
  'cdnResources.detail.tabKey3.Panel6.p2': '约翰内斯堡，南非',
  'cdnResources.detail.tabKey4.tip':
    '清除工具允许您立即从所有数据中心删除缓存内容。您可以使用特定路径单独清除文件，也可以一次清除所有文件。',
  'cdnResources.detail.tabKey4.tip.0': '你也可以选择使用API进行操作，API地址以及API密钥请前往',
  'cdnResources.detail.tabKey4.tip.1': '账号管理',
  'cdnResources.detail.tabKey4.tip.2': '中查看。',
  'cdnResources.detail.tabKey4.Radio1': '清除所有文件',
  'cdnResources.detail.tabKey4.Radio2': '清除特定文件',
  'cdnResources.detail.tabKey4.Radio3': '清除特定目录',
  'cdnResources.detail.tabKey4.Radio3.0': 'URL目录',
  'cdnResources.detail.tabKey4.Prefetch.placeholder':
    'https://www.example.com/ （多路径需要换行填写）',
  'cdnResources.detail.tabKey4.Radio2.purgeFiles.placeholder':
    'https://www.example.com/images/image01.png （多路径需要换行填写）',
  'cdnResources.detail.tabKey4.Radio2.purgePaths.message': '请输入清除路径',
  'cdnResources.detail.tabKey4.Radio2.purgePaths.placeholder':
    'https://www.example.com/images/ （多路径需要换行填写）',
  'cdnResources.detail.tabKey4.Radio2.purgePaths.Button': '清除特定文件',
  'cdnResources.detail.tabKey4.Radio2.errorMsg':
    '无效格式。支持 "https://www.example.com/images/image01.png"。',
  'cdnResources.detail.tabKey4.Radio3.errorMsg':
    '无效格式。支持 "https://www.example.com/images/"。',
  'cdnResources.detail.tabKey4.ProCard.title': '清除日志',
  'cdnResources.detail.tabKey4.ProCard.inprocess': '清除中...',
  'cdnResources.detail.tabKey4.ProCard.subTitle': '（仅保存3个月的日志数据）',
  'cdnResources.detail.tabKey4.ProCard.Option1': '所有日志',
  'cdnResources.detail.tabKey4.ProCard.Option2': '清除所有文件',
  'cdnResources.detail.tabKey4.ProCard.Option3': '清除特定文件',
  'cdnResources.detail.tabKey4.columns.purgePaths.Button': '查看文件路径',
  'cdnResources.detail.tabKey4.selected.message': '请确保你至少选择了一个边缘位置加速。',
  'cdnResources.detail.tabKey4.Modal.title': '文件路径',
  'cdnResources.detail.tabKey4.Modal.text': '所有文件',
  'cdnResources.detail.tabKey4.ModalPurge.title': '清除所有文件',
  'cdnResources.detail.tabKey4.ModalPurge.text':
    '如果您选择清除所有文件，我们将再次从您的源中提取文件。是否确实要清除所有缓存？',
  'cdnResources.detail.tabKey4.ModalPurge.button': '是的，我确定。',
  'cdnResources.detail.tabKey4.Modal.node.title': '加速节点列表',
  'cdnResources.detail.tabKey4.Modal.node.tip': '保存后，你将加速的节点为：',
  'cdnResources.detail.tabKey4.operateResult.COMPLETED': '完成',
  'cdnResources.detail.tabKey4.operateResult.IN_PROCESS': '进行中',
  'cdnResources.detail.tabKey4.operateResult.FAILED': '失败',

  'cdnResources.detail.tabKey5.onSuccess.message': '提交成功',
  'cdnResources.detail.tabKey5.tip': `预存允许您将新添加的内容预填充到CDN缓存中。这是如果你最近上传了一个大文件到你的服务器上，特别有用，因为您可以快速提示缓存服务器获取该文件并强制它们缓存该文件。`,
  'cdnResources.detail.tabKey5.Form.prefetchPaths.message': '请输入预存路径',
  'cdnResources.detail.tabKey5.Form.prefetchPaths.Button': '预存特定路径',
  'cdnResources.detail.tabKey5.Prefetchlog.title': '预存日志',
  'cdnResources.detail.tabKey5.Prefetchlog.inprocess': '预存中...',
  'cdnResources.detail.tabKey5.validatorPaths.message00': '多行文本不能超过 10 行',
  'cdnResources.detail.tabKey5.validatorPaths.message01': '域名长度不超过 250 个字符',
  'cdnResources.detail.tabKey5.validatorPaths.message0':
    '无效URL，URL必须以http(s)://开头，且域名属于已配置的加速域名。',
  'cdnResources.detail.tabKey5.validatorPaths.message1':
    '无效URL，URL必须以http(s)://开头的完整路径，且域名属于已配置的加速域名。',
  'cdnResources.detail.tabKey5.validatorPaths.message2':
    '无效URL，当前未配置有效SSL证书，只可预热http前缀的加速域名。',
  'cdnResources.detail.tabKey6.title1': '用CNAME配置',
  'cdnResources.detail.tabKey6.text1': '通过DNS加速所有静态文件。',
  'cdnResources.detail.tabKey6.text2': '1.您可以在您的域名服务商处添加CNAME',
  'cdnResources.detail.tabKey6.text3': '加速域名：',
  'cdnResources.detail.tabKey6.text4': 'CNAME：',
  'cdnResources.detail.tabKey6.text4.tip':
    '请注意，cname域名将不再开放直接访问的权限。这将保证所有用户的安全性。',
  'cdnResources.detail.tabKey6.text5': '2.DNS生成需要一些时间。您可以使用以下工具检查DNS',
  'cdnResources.detail.tabKey6.text6': '状态：',
  'cdnResources.detail.tabKey6.text7': '3.这就完成了！',
  'cdnResources.detail.tabKey6.text8': '开始您的LightCDN CDN之旅！如果您有任何其他问题，请联系我们',
  'cdnResources.detail.tabKey6.text9': '客服',
  'cdnResources.detail.tabKey6.title2': '不用CNAME配置',
  'cdnResources.detail.tabKey6.title11': '简单的设置，只需更新指向静态文件的URL。',
  'cdnResources.detail.tabKey6.title12':
    '1.更改需要CDN加速的每个文件（图像、视频、CSS等）的源路径：',
  'cdnResources.detail.tabKey6.title13': '不用CDN：',
  'cdnResources.detail.tabKey6.title14': '用CDN：',
  'cdnResources.detail.tabKey6.text15': '2.这就完成了！',
  //v1.3.3
  'cdnResources.detail.tabKey6.ActivateDiagnosis.imgText': '点击诊断，自助查询域名加速情况',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.url.placeholder': '填写可访问的路径',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.btnText': '诊断',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.reBtnText': '重新诊断',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.status.success': '正常运行',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.status.error': '错误警告',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.status.warn': '有异常',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.btnTimeText': '最近诊断时间：',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.text.1': '解析正常',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.text.2': '未解析',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.text.3': '解析异常',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.text.3.tip': '未解析到正确的地址',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.name': 'DNS解析',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step2.text.1': '已配置',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step2.text.2': '未配置',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step2.textTo': '前往配置',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step2.name': 'SSL证书',
  // 'cdnResources.detail.tabKey6.ActivateDiagnosis.step3.text': '500',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step3.name': '页面状态',
  // 'cdnResources.detail.tabKey6.ActivateDiagnosis.step4.text': "",
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step4.name': '加速情况',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.testPlace': '测试地区',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.testDomain': '测试域名',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.invalidURL': '无效URL，该路径不存在',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.moreTip':
    '不是这个问题？ 查看更多常见问题，对应处理 →',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.TLS13': 'TLS1.3 暂不支持诊断',

  'cdnResources.detail.tabKey7.title': '访问保护',
  'cdnResources.detail.tabKey7.accessCountry.name': '国家白名单',
  'cdnResources.detail.tabKey7.CountryAccess.p1':
    '配置规则以启用/禁用对指定国家/地区CDN资源内容的访问。',
  'cdnResources.detail.tabKey7.CountryAccess.p2': '你{val}访问，除了部分国家。',
  'cdnResources.detail.tabKey7.clickHere': '点击此处查看列表。',
  'cdnResources.detail.tabKey7.countries.title': '（以下国家/地区除外）', //，可不填写
  'cdnResources.detail.tabKey7.accessHotlink.name': 'URL白名单',
  'cdnResources.detail.tabKey7.hotlinkPolicy.p1':
    '配置一个规则，以启用/禁用对指定URL的CDN资源内容的访问。',
  'cdnResources.detail.tabKey7.hotlinkPolicy.p2': '你{val}访问，除了部分域名。 ',
  'cdnResources.detail.tabKey7.hotlinkPolicy.p3': '（CDN加速域名将被默认添加。）',
  'cdnResources.detail.tabKey7.domians.title': '（以下域名除外）', //，可不填写
  'cdnResources.detail.tabKey1.domians.message': '请输入域名！',
  'cdnResources.detail.tabKey1.domians.placeholder':
    'www.example.com/*.example.com（多个域名需要换行填写。）',
  'cdnResources.detail.tabKey7.accessIp.name': 'IP白名单',
  'cdnResources.detail.tabKey7.IPAccess.p1':
    '配置一个规则，以启用/禁用对一系列IP地址（包括IPv4和IPv6）的CDN资源内容的访问。',
  'cdnResources.detail.tabKey7.IPAccess.p2': '你{val}，除了部分IP地址。',
  'cdnResources.detail.tabKey7.addresses.title': '（以下IP地址除外）', //，可不填写
  'cdnResources.detail.tabKey1.addresses.message': '请输入IP地址！',
  'cdnResources.detail.tabKey1.addresses.placeholder':
    '10.10.10.10\n20.20.20.0/24\n2001:CDBA::64\n...',
  'cdnResources.detail.tabKey7.urlSigningVO.name': 'URL签名',
  'cdnResources.detail.tabKey7.URLSigning.p1': '使用密钥保护您的文件免受未经授权的访问。 ',
  'cdnResources.detail.tabKey7.signingKey.title': 'URL签名秘钥',
  'cdnResources.detail.tabKey7.URLSigning.Generate': '生成一个新的',
  'cdnResources.detail.tabKey7.URLSigning.message': '请输入6-32的字符串，不支持空格。',
  'cdnResources.detail.tabKey7.URLSigning.validatorMessage': 'URL签名密钥无效。',
  'cdnResources.detail.tabKey7.URLSigning.form.Param': '参数',
  'cdnResources.detail.tabKey7.URLSigning.form.Value': '值',
  'cdnResources.detail.tabKey7.URLSigning.form.Key': '秘钥',
  'cdnResources.detail.tabKey7.URLSigning.form.Param.pop':
    '默认值为“sign”,如果你的加密串是其他的参数，请填写。',
  'cdnResources.detail.tabKey7.URLSigning.form.TTL.pop':
    '链接的有效时间。由于URL鉴权是动态生成URL的，所以链接所在的页面的缓存时间设置不能超过鉴权设置的有效时间。',
  'cdnResources.detail.tabKey7.crawlers.name': '阻止搜索引擎爬网程序',
  'cdnResources.detail.tabKey7.crawlers.p1':
    '阻止搜索引擎爬网程序用于阻止网络爬网机器人对CDN内容进行索引。',
  'cdnResources.detail.tabKey7.Modal.here.title': '{name}列表',
  'cdnResources.detail.tabKey7.Modal.here.tip': '你{val}，除了：',
  'cdnResources.detail.tabKey7.SafetyWaf.name': 'OWASP最大威胁',
  'cdnResources.detail.tabKey7.SafetyWaf.title': 'WAF',
  'cdnResources.detail.tabKey7.SafetyWaf.tip1': '如果您不知道OWSAP的具体定义，可以查看',
  'cdnResources.detail.tabKey7.SafetyWaf.tip2': '文档',
  'cdnResources.detail.tabKey7.SafetyWaf.tip3': '去了解。',
  'cdnResources.detail.tabKey7.URLSigning.pop1': '安全令牌由以下参数组成：',
  'cdnResources.detail.tabKey7.URLSigning.pop2':
    'Expires — URL的到期时间或URL变得无效的时间。时间以Unix时间戳格式在URL中传递，并参与哈希生成。它是一个可选参数。',
  'cdnResources.detail.tabKey7.URLSigning.pop3': 'Path — 文件路径或文件目录',
  'cdnResources.detail.tabKey7.URLSigning.pop4': 'Key — 一个URL签名秘钥',
  'cdnResources.detail.tabKey7.URLSigning.pop5':
    'IP — 提供访问的IP。它是可选的，每次生成哈希键时只允许使用一个IP。',
  'cdnResources.detail.tabKey7.URLSigning.pop6': 'URL签名可以采用以下格式之一：',
  'cdnResources.detail.tabKey7.URLSigning.pop7':
    '查询字符串格式： http://example.com/filename?secure=DMF1ucDxtqgxwYQ&expires=1546300800&ip=1.2.3.4',
  'cdnResources.detail.tabKey7.URLSigning.pop8':
    '路径格式：http://example.com/secure=DMF1ucDxtqgxwYQ&expires=1546300800&ip=1.2.3.4/filename',
  'cdnResources.detail.tabKey7.Access.label1': '未开启',
  'cdnResources.detail.tabKey7.Access.label2': '默认开启所有',
  'cdnResources.detail.tabKey7.Access.label3': '默认阻止所有',
  'cdnResources.detail.tabKey7.allowed': '默认开启所有',
  'cdnResources.detail.tabKey7.block': '默认阻止所有',
  'cdnResources.detail.tabKey7.disabled': '未开启',
  'cdnResources.detail.tabKey7.SafetyNginx.title': 'Nginx设置',
  'cdnResources.detail.tabKey7.SafetyNginx.title1': '速率设置',
  'cdnResources.detail.tabKey7.SafetyNginx.title2': '缓存键',
  'cdnResources.detail.tabKey7.SafetyNginx.text1': '支持限制客户每个请求的相应速度。',
  'cdnResources.detail.tabKey7.SafetyNginx.text2': '当前设置：当请求达到了',
  'cdnResources.detail.tabKey7.SafetyNginx.text3': '，响应速度将降至',
  'cdnResources.detail.tabKey7.SafetyNginx.text4': '支持从四种类型的缓存键中选择一种进行缓存。',
  'cdnResources.detail.tabKey7.SafetyNginx.message': '请不要超过2T。',
  // v1.1.13
  'cdnResources.detail.tabKey8.tabs1': '缓存规则',
  'cdnResources.detail.tabKey8.tabs2': '重定向规则',
  'cdnResources.detail.tabKey8.tabs3': '修改标头',
  'cdnResources.detail.tabKey8.tabs3.1': '请求标头',
  'cdnResources.detail.tabKey8.tabs3.2': '响应标头',
  'cdnResources.detail.tabKey8.tabs3.3': '在请求标头中获取客户端IP',
  'cdnResources.detail.tabKey8.tabs3.header': '标头',
  'cdnResources.detail.tabKey8.tabs3.Edit.succeeded': '编辑成功',
  'cdnResources.detail.tabKey8.tabs4': '源规则',
  'cdnResources.detail.tabKey8.tabs.tip0': '如何绕过 LightCDN 的边缘服务器直接访问源呢？',
  'cdnResources.detail.tabKey8.tabs.tip1': '通过CDN访问源站提示重定向的次数过多？',
  'cdnResources.detail.tabKey8.tabs.tip2': '来看看如何解决吧！→',
  'cdnResources.detail.tabKey8.tabs.tip3': '来看看如何解决吧！→',
  'cdnResources.detail.tabKey8.tabs1.create': '创建一条新的规则', // {num}
  'cdnResources.detail.tabKey8.tabs1.p1': '自定义HTTP缓存规则。',
  'cdnResources.detail.tabKey8.tabs1.p2': '阅读文档来了解更多。',
  'cdnResources.detail.tabKey8.tabs1.p3.1': '你当前可以创建',
  'cdnResources.detail.tabKey8.tabs1.p3.2': '条规则。',
  'cdnResources.detail.tabKey8.tabs1.p3.3': '去购买更多的规则。',
  'cdnResources.detail.tabKey8.tabs1.p4': '去购买更多的规则。',
  'cdnResources.detail.tabKey8.tabs1.table.title1': '名称',
  'cdnResources.detail.tabKey8.tabs1.table.title2': '选项',
  'cdnResources.detail.tabKey8.tabs1.table.compensation': '系统补偿',
  'cdnResources.detail.tabKey8.tabs1.form.title1.message': '请输入名称！',
  'cdnResources.detail.tabKey8.tabs1.form.title1.exists': '规则名称已存在。',
  'cdnResources.detail.tabKey8.tabs1.form.title1.invalidName': '无效名称，请输入字母或数字。',
  'cdnResources.detail.tabKey8.tabs1.form.invalidName': '无效名称',
  'cdnResources.detail.tabKey8.tabs1.form.title1.cnMessage': '请输入字母或数字。',
  'cdnResources.detail.tabKey8.tabs1.form.title1.button': '生成一个名称',
  'cdnResources.detail.tabKey8.tabs1.form.title2': '条件（传入请求匹配…时）',
  'cdnResources.detail.tabKey8.tabs1.form.title3': '操作（然后…）',
  'cdnResources.detail.tabKey8.tabs1.form.title4': '动作',
  'cdnResources.detail.tabKey8.tabs1.form.title4.message': '请选择动作',
  'cdnResources.detail.tabKey8.tabs1.form.title4.message1': '请至少选择一个动作开启。',
  'cdnResources.detail.tabKey8.tabs1.form.title5': '从不缓存',
  'cdnResources.detail.tabKey8.tabs1.form.title6': '缓存',
  'cdnResources.detail.tabKey8.tabs1.form.title7': '强制边缘从不缓存',
  'cdnResources.detail.tabKey8.tabs1.form.title8': '强制客户端从不缓存',
  'cdnResources.detail.tabKey8.tabs1.form.title9': '强制边缘缓存',
  'cdnResources.detail.tabKey8.tabs1.form.title10': '强制客户端缓存',
  'cdnResources.detail.tabKey8.tabs1.form.title11': '覆盖默认缓存有效性',
  'cdnResources.detail.tabKey8.tabs1.form.title12': 'TTL',
  'cdnResources.detail.tabKey8.tabs1.form.title12.message': '请输入TTL',
  'cdnResources.detail.tabKey8.tabs1.form.title7.text':
    '强制CDN边缘服务器从不缓存请求。但是，如果请求已经缓存（例如，如果它是在设置此规则之前缓存的），则不会强制将其从缓存中取出。',
  'cdnResources.detail.tabKey8.tabs1.form.title8.text':
    '强制客户端从不缓存请求。这是通过删除所有“Cache-Control”和“Expires”响应标头来实现的，而非发送“Cache-Control: no-cache”。',
  'cdnResources.detail.tabKey8.tabs1.form.title9.text':
    '强制CDN边缘服务器将请求缓存指定的持续时间。这将覆盖来自源的任何“Cache-Control”或“Expires”标头，即使它们指定了“private”或“no-cache”。',
  'cdnResources.detail.tabKey8.tabs1.form.title9.second':
    '这将覆盖来自源的任何“Cache-Control”或“Expires”标头，即使它们指定了“private”或“no-cache”。值必须填写1min或更长。',
  'cdnResources.detail.tabKey8.tabs1.form.title9.text.0':
    '强制CDN边缘服务器将请求缓存指定的持续时间。这个功能适用于',
  'cdnResources.detail.tabKey8.tabs1.form.title9.text.1': '内容更新不频繁',
  'cdnResources.detail.tabKey8.tabs1.form.title9.text.2': '的业务场景。',
  'cdnResources.detail.tabKey8.tabs1.form.title10.text.0':
    '强制客户端将请求缓存指定的持续时间。这个功能适用于',
  'cdnResources.detail.tabKey8.tabs1.form.title10.text.1': '内容需要频繁更新',
  'cdnResources.detail.tabKey8.tabs1.form.title10.text.2': '的业务场景。',
  'cdnResources.detail.tabKey8.tabs1.form.title10.text.3':
    '这将覆盖来自源的任何“Cache-Control”或“Expires”标头，即使它们指定了“private”或“no-cache”。值必须填写1min或更长。',
  'cdnResources.detail.tabKey8.tabs1.form.title11.text':
    '为未明确指定“Cache-Control”或“Expires”的源响应更改CDN边缘服务器的默认有效期。具有“Cache Control”或“Expires”标头的响应仍将被接受。',
  'cdnResources.detail.tabKey8.tabs1.form.item1.name': '条件',
  'cdnResources.detail.tabKey8.tabs1.form.item2.name': '主题',
  'cdnResources.detail.tabKey8.tabs1.form.item3.name': 'Cookie/Param参数/Header标头',
  'cdnResources.detail.tabKey8.tabs1.form.item3.message': '请输入Cookie/Param参数/Header标头',
  'cdnResources.detail.tabKey8.tabs1.form.item4.name': '谓语',
  'cdnResources.detail.tabKey8.tabs1.form.item5.name': '值',
  'cdnResources.detail.tabKey8.tabs1.form.item5.message': '请输入值',
  'cdnResources.detail.tabKey8.tabs1.form.create': '创建一条新的规则',
  'cdnResources.detail.tabKey8.tabs1.form.save': '保存修改',
  'cdnResources.detail.tabKey8.tabs1.form.extensionEqual.tip':
    'Tips: extension的主题允许你一个条件中填入多个拓展名，请用英文字符[,]间隔开拓展名。',
  'cdnResources.detail.tabKey8.tabs1.form.IP.tip':
    'Tips: IP的主题允许你一个条件中填入多个IP。当你选择的是in range，有两种格式可选择。',
  'cdnResources.detail.tabKey8.tabs1.form.IP.tip.0':
    '（1）开始ip,结束ip ,并英文横杆[-]隔开。例子： 192.168.1.100-192.168.2.200',
  'cdnResources.detail.tabKey8.tabs1.form.IP.tip.1': '（2）CIDR格式。例子：192.168.2.1/24',
  'cdnResources.detail.tabKey8.tabs1.form.IP.tip.2':
    '（3）多个单IP,并英文逗号[,]隔开。例子：1.1.1.1,2.2.2.2',
  //v1.3.3
  'cdnResources.detail.tabKey8.tabs1.form.url.tip':
    '提示：URL主题的格式应遵循完整的请求URL，包括协议、域名、请求路径、参数等，类似http://cdn.example.com/image.jpg?name=cdn 。',

  'cdnResources.detail.tabKey8.tabs1.PopoverText1': '编辑',
  'cdnResources.detail.tabKey8.tabs1.PopoverText2': '删除',
  'cdnResources.detail.tabKey8.tabs1.Delete.content':
    '删除后，该规则将变为无效。你确定要删除它吗？',
  'cdnResources.detail.tabKey8.tabs2.title': '快速开启配置',
  'cdnResources.detail.tabKey8.tabs2.QuicklyEnable': '快速开启',
  'cdnResources.detail.tabKey8.tabs2.card.title': 'HTTPS重定向',
  'cdnResources.detail.tabKey8.tabs2.card.p1':
    '返回从http地址到https地址的301重定向响应，而不是从缓存或上游加载。',
  'cdnResources.detail.tabKey8.tabs2.card.p2':
    '我们将直接为您生成一个规则，并将其显示在下面的列表中。',
  'cdnResources.detail.tabKey8.tabs2.code.name1': '重定向功能',
  'cdnResources.detail.tabKey8.tabs2.code.name2': '规则列表',
  'cdnResources.detail.tabKey8.tabs2.code.title': '全站重定向',
  'cdnResources.detail.tabKey8.tabs2.code.p':
    '请注意，开启全站重定向后，该规则将优先于其他规则，访问到加速域名的所有请求都将自动跳转至你设置的域名。填写的URL若不包含前缀，http/https，将默认保持协议。',
  'cdnResources.detail.tabKey8.tabs2.code.col.1': '跳转后的URL',
  'cdnResources.detail.tabKey8.tabs2.code.col.message': '请输入跳转后的URL',
  'cdnResources.detail.tabKey8.tabs2.code.col.2': '状态码',
  'cdnResources.detail.tabKey8.tabs2.code.col.302': '302 - 临时重定向',
  'cdnResources.detail.tabKey8.tabs2.code.col.301': '301 - 永久重定向',
  'cdnResources.detail.tabKey8.tabs2.p1': '创建规则将访问者从源URL重定向到目标URL。',
  'cdnResources.detail.tabKey8.tabs2.form.title1': '禁止访问客户端',
  'cdnResources.detail.tabKey8.tabs2.form.title2': '设置重定向',
  'cdnResources.detail.tabKey8.tabs2.form.title3': '将客户端从HTTP重定向到HTTPs',
  'cdnResources.detail.tabKey8.tabs2.form.title4': '重定向客户端',
  'cdnResources.detail.tabKey8.tabs2.form.title5': 'URL',
  'cdnResources.detail.tabKey8.tabs2.form.title5.message': '请输入URL',
  'cdnResources.detail.tabKey8.tabs2.form.title1.text': '向客户端返回一个简单的403 Forbidden响应。',
  'cdnResources.detail.tabKey8.tabs2.form.title2.text':
    '返回从http地址到https地址的301重定向响应，而不是从缓存或上游加载。',
  'cdnResources.detail.tabKey8.tabs2.form.title2.text.1': '资源存在多个加速域名时，需要选定一个。',
  'cdnResources.detail.tabKey8.tabs2.form.title3.text':
    '将302重定向响应返回到客户端的指定URL。这将作用于所有的加速域名。填写的URL若不包含前缀，',
  'cdnResources.detail.tabKey8.tabs2.form.title3.text1': '，将默认保持协议。',
  'cdnResources.detail.tabKey8.tabs2.form.title3.select.text': '重定向对象',
  'cdnResources.detail.tabKey8.tabs3.p1': '调整边缘的请求的HTTP标头。',
  'cdnResources.detail.tabKey8.tabs3.p2': '调整边缘的响应的HTTP标头。',
  'cdnResources.detail.tabKey8.tabs3.p2.0':
    '从请求标头中获取客户端IP。必须提供标头名称。常见的标头有',
  'cdnResources.detail.tabKey8.tabs3.p2.1': 'X-Forwarded-For、X-Real-IP、X-Client-IP',
  'cdnResources.detail.tabKey8.tabs3.p2.2': '等。',
  'cdnResources.detail.tabKey8.tabs3.form.title1': '设置请求标头',
  'cdnResources.detail.tabKey8.tabs3.form.title2': '设置响应标头',
  'cdnResources.detail.tabKey8.tabs3.form.title3': '在请求标头中设置客户端IP',
  'cdnResources.detail.tabKey8.tabs3.form.title1.create': '创建请求标头',
  'cdnResources.detail.tabKey8.tabs3.form.title2.create': '创建响应标头',
  'cdnResources.detail.tabKey8.tabs3.form.title1.Header': '标头',
  'cdnResources.detail.tabKey8.tabs3.form.title1.Header.message': '请输入标头',
  'cdnResources.detail.tabKey8.tabs3.form.title1.HeaderValue.message': '请输入标头和值',
  'cdnResources.detail.tabKey8.tabs3.form.title1.Value': '值',
  'cdnResources.detail.tabKey8.tabs3.form.title1.Value.message': '请输入值',
  'cdnResources.detail.tabKey8.tabs3.form.title1.text':
    '将请求标头覆盖到源。必须提供标头名称和标头值。',
  'cdnResources.detail.tabKey8.tabs3.form.title2.text':
    '覆盖客户端的响应标头。必须提供标头名称和标头值。',
  'cdnResources.detail.tabKey8.tabs3.form.title3.text':
    '将请求标头中客户端的IP地址设置为源。必须提供标头名称。',
  'cdnResources.detail.tabKey8.tabs3.form.title4.text':
    '将响应头覆盖到源。必须提供标头名称和标头值。',
  'cdnResources.detail.tabKey8.tabs4.p1': '自定义原始配置请求的目的地。',
  'cdnResources.detail.tabKey8.tabs4.form.title1': '准备源目录',
  'cdnResources.detail.tabKey8.tabs4.form.title2': '设置自定义源',
  'cdnResources.detail.tabKey8.tabs4.form.title3': '将HTTP主机头传递到源',
  'cdnResources.detail.tabKey8.tabs4.form.title4': '其他设置',
  'cdnResources.detail.tabKey8.tabs4.form.title1.text':
    '当边缘服务器从源位置请求时，将目录设置为预先准备的URL。',
  'cdnResources.detail.tabKey8.tabs4.form.title2.text': '替代边缘服务器连接到源。',
  'cdnResources.detail.tabKey8.tabs4.form.title3.text':
    '当条件为true时，返回原点，在第一次期间，并且随后的请求（缓存在边缘中）将不会再次返回原点，尽管条件为true。',
  'cdnResources.detail.tabKey8.InvalidFormat': '无效格式',
  'cdnResources.detail.tabKey8.tabs4.title.1': '回源主机名',
  'cdnResources.detail.tabKey8.tabs4.title.1.0':
    '回源主机名的选择影响到请求源站时接收到的域名。默认是CDN加速域名。还是不了解回源主机名，',
  'cdnResources.detail.tabKey8.tabs4.title.1.0.0': '点击查看更详细的内容→',
  'cdnResources.detail.tabKey8.tabs4.title.1.1.0':
    '跟随CDN域名："跟随CDN域名"是指源站接收到的域名和当前CDN加速域名保持一致。这种类型基本用于',
  'cdnResources.detail.tabKey8.tabs4.title.1.1.1': '源站支持多域名托管',
  'cdnResources.detail.tabKey8.tabs4.title.1.1.2': '的情况，精准匹配请求，避免404/400错误。',
  'cdnResources.detail.tabKey8.tabs4.title.1.2.0':
    '跟随源站：跟随源站"是指源站接收到的域名仍然是填写的源站地址中的信息，不随代理服务域名改变而改变。',
  'cdnResources.detail.tabKey8.tabs4.title.1.2.1': '多用于源站仅服务单一域名',
  'cdnResources.detail.tabKey8.tabs4.title.1.2.2': '，兼容性好，无需修改源站配置。',
  'cdnResources.detail.tabKey8.tabs4.title.1.3': '自定义：自定义Host内容中支持请求变量。',
  'cdnResources.detail.tabKey8.tabs4.title.1.type1': '跟随CDN域名',
  'cdnResources.detail.tabKey8.tabs4.title.1.type2': '跟随源站',
  'cdnResources.detail.tabKey8.tabs4.title.1.type3': '自定义',
  'cdnResources.detail.tabKey8.tabs4.title.2': '准备源目录',
  'cdnResources.detail.tabKey8.tabs4.title.2.0':
    '当边缘服务器从源请求时，将目录设置为预先准备的URL。比如值为',
  'cdnResources.detail.tabKey8.tabs4.title.2.00': '“images”',
  'cdnResources.detail.tabKey8.tabs4.title.2.1': '，客户端向边缘服务器请求：',
  'cdnResources.detail.tabKey8.tabs4.title.2.10': '“http://cdn.example.com/photo.jpg”',
  'cdnResources.detail.tabKey8.tabs4.title.2.2': '， 边缘服务器向源请求：',
  'cdnResources.detail.tabKey8.tabs4.title.2.20': '“http://cdn.example.com/images/photo.jpg”。',
  'cdnResources.detail.tabKey8.tabs4.title.3': '自动添加标头',
  'cdnResources.detail.tabKey8.tabs4.title.3.0':
    '选中后，会自动向源站请求添加这些报头，以便于源站获取客户端信息。',

  'cdnResources.detail.tabKey8.tabs4.RequestLimiting': '请求限制',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.1': '最大并发数',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.1.0':
    '当前网站的最大并发出，超过此限制将会以 429 状态码的结果返回给用户。',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.1.1': '值为0表示没有限制。',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.2': '每个IP的最大并发数',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.2.0':
    '每个IP的最大并发数。统计单IP的总连接数时，不区分网站。如果超过限制，将会以 429 状态码的结果返回给用户。',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.2.1': '值为0表示没有限制。',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.3': '每个请求的带宽限制',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.3.0': '客户端单个请求每秒可以读取的下行流量。',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.3.1': '可以为空。',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.4': '每个请求的最大内容大小',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.4.0': '单个请求能发送的最大内容大小。',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.4.1': '可以为空。',
  'cdnResources.detail.tabKey8.tabs4.EnabledMode': ' 启用模式',
  'cdnResources.detail.tabKey8.tabs4.CurrentSetting': '当前设置：',
  'cdnResources.detail.tabKey8.tabs4.Unlimited': '不限制',
  //v1.3.6
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title': 'CC防护',
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title1': '防护设置',
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title2': '访问统计',
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title3': '被拦截IP',
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title4': 'CC白名单',
  'cdnResources.detail.tabKey8.tabs6.5SShield.title': '5秒盾',
  'cdnResources.detail.tabKey8.tabs5.CCSet.title': '防护设置',
  'cdnResources.detail.tabKey8.tabs5.CCSet.text': '开启CC防护',
  'cdnResources.detail.tabKey8.tabs5.CCSet.tip1': '不知道什么是CC防护？',
  'cdnResources.detail.tabKey8.tabs5.CCSet.tip2': '该如何使用，前往查看 →',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1': '拦截阈值',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text1':
    '自动 - 将根据网站访问量自动动态设置阈值，推荐大多数场景。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text2':
    '默认 - 使用预设安全值，适合流量较为稳定的业务。当前系统默认阈值设置：单IP 每 5 秒 最多 60 请求； 每 60 秒 最多 150 请求； 每 300 秒 最多 300 请求。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text3': '自定义 - 手动设置，需熟悉业务流量。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text.content1': '单IP每5秒最多',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text.content2': '单IP每60秒最多',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text.content3': '单IP每300秒最多',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text.content4': '请求',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav2': '拦截强度',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav2.text': '级别越高，被拦截的IP封禁时间越长。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav3': '忽略常用文件',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav3.text':
    '忽略js、css、jpg等常在网页里被引用的文件名，即对这些文件的访问不加入计数，可以减少误判几率。但如果单独访问这些文件，比如在浏览器里直接打开，也会加入计数。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav4': '检查请求来源指纹',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav4.text':
    '在接收到HTTPS请求时尝试检查请求来源的指纹，用来检测代理服务和爬虫攻击；如果你在网站前面放置了别的反向代理服务，请取消此选项。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav5': 'GET302校验',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav5.text':
    '开启后，表示自动通过GET302方法来校验客户端。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav6': '检测阈值',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav6.text':
    '当某个IP在1分钟内平均QPS达到此值时，才会开始检测；为0，表示任何访问都会检测。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav6.text.content1': '单IP最低QPS',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav6.text.content2': '请求数/秒',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav7': '防护范围',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav7.text1':
    '填写名单用于区别特殊配置的内容。当前选择防护名单，表示只对这些URL进行CC防护。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav7.text2':
    '填写名单用于区别特殊配置的内容。当前选择排除名单，表示这些URL跳过CC防护不做处理。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav8': '邮件警告',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav8.text':
    '开启后，当有疑似风险或者触发CC防护自动拦截时，发送邮件警告。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.suggestion': '建议开启',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.tip1':
    'IP即时访问量为最近五分钟的预估量。拉黑的IP你可以前往',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.tip2': '拦截IP',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.tip3': '中查看 →',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.column1': 'IP信息',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.column2': '平均访问量',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.column3': '总访问量',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.column4': '操作',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIP': '拉黑IP',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.whiteIP': '加入白名单',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item0': 'IP或IP段',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item1': 'IP',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item2': '自动解除时间',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item3': '备注',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item4': '一键选择：',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item5': '1小时',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item6': '1天',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item7': '3天',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item8': '1周',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item9': '30天',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item10': '1年',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.defaultReason': '疑似CC攻击',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.btn': '新增黑名单IP',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.Modal.placeholder':
    '10.10.10.10\n20.20.20.0/24\n2001:CDBA::64\n多个请换行，支持IPv4或IPv6',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.column1': '拦截结束时间',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.column2': '拦截原因',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.column3': '请求路径',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.remove': '解除',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.intercepted': '已拦截',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.title': '解除拦截',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.text1': '该IP',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.text2': '预计在',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.text3': '解除拦截。',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.text4': '是否确认当前解除拦截？',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.tip': '加入CC白名单的IP，将跳过CC防护的检测。',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.addButton': '新增CC白名单',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.column1': '类型',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.column2': '创建时间',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.delete': '删除',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.addButton.btnText': '新增白名单IP',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.deleteModal.text': '是否确认从白名单中移除IP',
  'cdnResources.detail.tabKey8.tabs5.SShield.text': '开启5秒盾',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav1': '验证有效期',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav1.text':
    '单个客户端验证通过后，在这个有效期内不再重复验证；如果为0则表示系统默认。',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav1.second': '秒',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav2': '单IP最低QPS',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav2.text':
    '当某个IP在1分钟内平均QPS达到此值时，才会触发5秒盾；如果设置为0，表示任何访问都会触发。',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav3': '加入IP白名单',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav3.text':
    '开启后，验证通过的IP将加入临时白名单，此IP下次访问时不再校验5秒盾；此白名单只对5秒盾有效，不影响其他规则。此选项主要用于可能无法正常使用Cookie的网站。',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav4': '防护范围',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav4.text1':
    '填写名单用于区别特殊配置的内容。当前选择防护名单，表示只对这些URL进行5秒盾保护。',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav4.text2':
    '填写名单用于区别特殊配置的内容。当前选择排除名单，表示这些URL跳过5秒盾不做处理。',
  'cdnResources.detail.tabKey8.tabs5.enum.threshold.0': '自动',
  'cdnResources.detail.tabKey8.tabs5.enum.threshold.1': '默认',
  'cdnResources.detail.tabKey8.tabs5.enum.threshold.2': '自定义',
  'cdnResources.detail.tabKey8.tabs5.enum.strength.0': '低',
  'cdnResources.detail.tabKey8.tabs5.enum.strength.1': '中',
  'cdnResources.detail.tabKey8.tabs5.enum.strength.2': '高',
  'cdnResources.detail.tabKey8.tabs5.enum.range.0': '未开启',
  'cdnResources.detail.tabKey8.tabs5.enum.range.1': '防护名单',
  'cdnResources.detail.tabKey8.tabs5.enum.range.2': '排除名单',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0': '通配符',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.placeholder':
    '使用星号(*)通配符，不区分大小写',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip0': '通配符示例：',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip1': '单个路径开头：/hello/world/*',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip2': '单个路径结尾：*/hello/world',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip3': '包含某个路径：*/article/*',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip4': '某个域名下的所有URL：*.example.com/*',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip5': '忽略某个扩展名：*.js',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.1': '常见图片',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.2': '常见视频',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.4': '常见音频',
  //v1.3.2
  'cdnResources.detail.tabKey9.title1': '页面优化',
  'cdnResources.detail.tabKey9.title2': '内容压缩',
  'cdnResources.detail.tabKey9.title3': '缓存优化',
  'cdnResources.detail.tabKey9.PageOptimize.title': '静态文件优化',
  'cdnResources.detail.tabKey9.PageOptimize.name1': 'HTML优化',
  'cdnResources.detail.tabKey9.PageOptimize.name2': 'Javascript优化',
  'cdnResources.detail.tabKey9.PageOptimize.name3': 'CSS优化',
  'cdnResources.detail.tabKey9.PageOptimize.name1.p':
    '可以自动优化HTML中包含的空白、注释、空标签等；只有文件可以缓存时才会被优化。',
  'cdnResources.detail.tabKey9.PageOptimize.name2.p':
    '可以自动缩短Javascript中变量、函数名称等。只有文件可以缓存时才会被优化。',
  'cdnResources.detail.tabKey9.PageOptimize.name3.p':
    '可以自动去除CSS中包含的空白。只有文件可以缓存时才会被优化。',
  'cdnResources.detail.tabKey9.GzipOptimize.title1': '压缩算法',
  'cdnResources.detail.tabKey9.GzipOptimize.title2': '图像算法',
  'cdnResources.detail.tabKey9.GzipOptimize.name1': '压缩启用',
  'cdnResources.detail.tabKey9.GzipOptimize.name2': 'WebP',
  'cdnResources.detail.tabKey9.GzipOptimize.name1.p':
    '快速的压缩算法，支持高压缩率和实时压缩性能。压缩算法的优先级按照排列顺序。',
  'cdnResources.detail.tabKey9.GzipOptimize.name2.p':
    '选中后表示开启自动WebP压缩；图片的宽和高均不能超过16383像素；只有缓存的图片内容才会被转换；最小缓存时间为：7200秒。',
  'cdnResources.detail.tabKey9.CacheOptimize.title': '缓存条件优化',
  'cdnResources.detail.tabKey9.CacheOptimize.name1': '忽略参数',
  'cdnResources.detail.tabKey9.CacheOptimize.name1.p1':
    '开启后，生成缓存Key时不包含URI参数，即问号（?）后面的内容。',
  'cdnResources.detail.tabKey9.CacheOptimize.name1.p2': '更多请查看文档 →',
};
